import React from 'react';
import { Search, MapPin, Zap, PiggyBank, Clock, Shield } from 'lucide-react';
import { features } from '../data/mock';

const iconMap = {
  Search: Search,
  MapPin: MapPin,
  Zap: Zap,
  PiggyBank: PiggyBank,
  Clock: Clock,
  Shield: Shield
};

export const FeaturesSection = () => {
  return (
    <section id="features" className="py-20 md:py-32 bg-bg-section">
      <div className="container">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-wash text-accent-text text-sm font-medium mb-4">
            Funzionalità
          </span>
          <h2 className="heading-2 mb-4">
            Tutto quello che serve per<br />
            <span className="text-accent-text">ricaricare meglio</span>
          </h2>
          <p className="body-large text-text-secondary">
            EasyVI è l'unica app che confronta i prezzi di tutti gli operatori,
            aiutandoti a risparmiare su ogni ricarica.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div key={feature.id} className="product-card group">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-accent-primary/20 to-accent-strong/20 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  {IconComponent && <IconComponent size={24} className="text-accent-text" />}
                </div>
                <h3 className="product-card-title">{feature.title}</h3>
                <p className="product-card-description">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
